import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackBarWarningComponent } from './snack-bar-warning.component';

@NgModule({
  declarations: [
    SnackBarWarningComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule
  ],
  exports: [
    SnackBarWarningComponent
  ]
})
export class SnackBarWarningModule { }
